export default [
  // This one should not be visible in dropdowns so we could add a flag hideInDropdown to hide it or we can continua adding a custom rule where needed. Define during rewrite.
  {
    alias: 'owner',
    name: 'Owner',
    description: 'Can do everything.',
  },
  {
    alias: 'admin',
    name: 'Admin',
    description: 'Can do everything other then adding or removing owners.',
  },
  {
    alias: 'team_lead',
    name: 'Team Lead',
    description: 'Can manage phone numbers associated with them.',
  },
  {
    alias: 'member',
    name: 'Member',
    description: 'Can communicate via phone numbers associated with them.',
  },
];
